@import '@vg-constellation/styles/components/tabs';
@import '@vg-constellation/styles/components/nav-overflow';
@import '@vg-constellation/styles/c11n';
@import '@vg-constellation/styles/global';
@import '@vg-constellation/styles/breakpoints';
@import "@vg-constellation/styles/variables/tokens";
@import '@vg-constellation/styles/icons';
@import '@vg-constellation/styles/components/label';
@import '@vg-constellation/styles/components/input';
@import '@vg-constellation/styles/components/button';
@import '@vg-constellation/styles/components/search';

.search-home-page {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    flex-direction: column;
    gap: 20px;
}

.search-home-page-header {
    width: 60%;
}

.search-home-page-tab {
    width: 60%;
    height: 600px;
    display: flex;
    flex-direction: column;
}


.code-block {
    background-color: #f4f4f4;
    border: 1px solid black;
    padding: 1em;
    font-family: 'Courier New', monospace;
    font-size: 14px;
    overflow-x: auto;
    white-space: pre;
    width: 96%;
}
    
.code-block code {
    color: #c7254e;
}    

.code-container {
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    button {
        border-radius: 0;
    }
}

.component-and-code-snippet-container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    gap: 10px;
    height: auto;
}